import { useQuery } from "react-query";
import { getProducerCodeListByListCarrierProducerCodeIds } from "../../../../actions/CarrierAgreementMgmt/ProducerCodeConfig";
import { toast } from "../../../../components/toastNotification";

export const useCarrierProducerCodeList = (args) => {
  return useQuery(
    ["CarrierProducerCodeList", args],
    () => getProducerCodeListByListCarrierProducerCodeIds(args),
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        if (res) {
          if (res.statusCode === 500 || res.statusCode === 400) {
            toast.fire("Server Error", "Cannot display data", "error");
          } else {
            res?.map((responseData) => {
              return {
                ...responseData,
              };
            });
          }
        } else {
          toast.fire("No Data:", "No avaible data to display.", "info");
        }
      },
    }
  );
};
